import React, { useRef, useEffect } from 'react'
import lottie from 'lottie-web'

import Page from '../common/Page'
import { CTAButton } from '../common/Button'
import { ProductQuestion, ProductDescription } from '../common/Text'

import appLogo from '../../assets/app-logo.svg'
import productImage from '../../assets/img_product_banner.png'
import btnPrev from '../../assets/btn-prev.svg'
import backgroundImg from '../../assets/bg_product.png'

const logoStyle = {
    width: '12rem', 
    height: '3.625rem',
    left: 0,
    right: 0,
    margin: 'auto'
}

const productImageStyle = {
    width: '100%',
    paddingTop: '1.5rem'
}

const ctaStyle = {
    width: '100%',
    height: '3.5rem',        
    marginTop: '2.5rem',
    borderRadius: '1.75rem',
    background: 'linear-gradient(90deg, rgba(255,0,199,1) 0%, rgba(255,114,0,1) 100%)'    
}

const upButtonStyle = {
    position: 'absolute',
    top: 0,
    right: 0,
    paddingTop: '0.25rem',
    paddingRight: '0.25rem',
    height: '2.25rem',
    width: '2.25rem'
}

export default function Product(props) {
    const lottieContainer = useRef()

    useEffect(() => {        
        lottie.loadAnimation({           
            container: lottieContainer.current,                       
            animationData: require('../../assets/ic_next.json')
        })                
    },[])

    return (
        <Page backgroundImg={backgroundImg}>            
            <div style={{textAlign: 'center', paddingTop: '1.75rem'}}>
                <img src={appLogo} alt={'Daily Bible Logo'} style={logoStyle}/>
                <img src={productImage} alt={'Product'} style={productImageStyle}/>
                <ProductQuestion style={{paddingTop: '1.25rem'}}>Talk to God everyday<br/>about how you feel.</ProductQuestion>
                <ProductDescription style={{paddingTop: '0.75rem'}}>You will feel less anxious<br/>and more at peace.</ProductDescription>
                <CTAButton style={ctaStyle} onClick={props.tapCTA}>
                    <div style={{float: 'left', marginRight: '0.25rem', marginLeft: '1.5rem', lineHeight: '2.25rem', textAlign: 'center',fontFamily: 'Montserrat', fontSize: '1.25rem' }}>Get Free Bible App</div>
                    <div ref={lottieContainer} style={{width: '2rem', height: '2.25rem', float: 'left', marginRight: '0.75rem'}}/>
                </CTAButton>   
            </div>            
            <img src={btnPrev} alt={'prev btn'} style={upButtonStyle} onClick={props.prevStep}/>
        </Page>
    )
}